import React, { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { IGiftCardDelivery } from '../../../../types';
import SimpleError from '../SimpleError/SimpleError';
import GiftCardContext, { clearError, updateGiftCardDelivery } from '../../GiftCardContext';
import { TextArea } from '../../../../components/TextArea/TextArea';
import DeliveryDate from '../DeliveryDate/DeliveryDate';
import styles from './DeliveryDetails.module.scss';

const SPLIT_NAME_REGEX = /([^ ]*) *(.*)/;

/**
 * Configure details for the gift card.
 */
export default function DeliveryDetails() {
  const { t } = useTranslation();
  const { giftCardState, giftCardDispatch } = useContext(GiftCardContext);
  const setValue = (newValue: string | null, propertyName: keyof IGiftCardDelivery, nonNull = false) =>
    giftCardDispatch(
      updateGiftCardDelivery({
        [propertyName]: nonNull ? newValue : newValue || null,
      }),
    );
  const setGifteeName = (fullName: string): void => {
    const [, firstName, lastName] = fullName.match(SPLIT_NAME_REGEX)!;
    setValue(firstName, 'firstName');
    setValue(lastName, 'lastName');
  };

  return (
    <div className={styles.deliveryDetails}>
      <h3>{t('who_is_it_for')}</h3>
      {/* TODO: Add validation */}
      <input
        type="text"
        placeholder={t('name')}
        onChange={(e) => setGifteeName(e.currentTarget.value)}
        onBlur={() => giftCardDispatch(clearError('gifteeName'))}
      />
      <SimpleError error={giftCardState.errors['gifteeName']} />
      <input
        type="email"
        placeholder={t('email_address_propercase')}
        onChange={(e) => setValue(e.currentTarget.value, 'emailAddress', true)}
        onBlur={() => giftCardDispatch(clearError('emailAddress'))}
      />
      <SimpleError error={giftCardState.errors['emailAddress']} />
      <h3>{t('from')}</h3>
      <input
        type="text"
        placeholder={t('your_name')}
        onChange={(e) => setValue(e.currentTarget.value, 'gifterName', false)}
        onBlur={() => giftCardDispatch(clearError('gifterName'))}
      />
      <SimpleError error={giftCardState.errors['gifterName']} />
      <h3>{t('message')}</h3>
      <TextArea
        onChange={(e) => setValue(e, 'personalMessage', false)}
        rows={10}
        placeholderText={t('type_in_any_message_you_want_delivered_with_the_gift')}
        characterLimit={255}
      />
      <DeliveryDate />
    </div>
  );
}
